// src/components/PrivateRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { authToken, magicToken, clientData } = useAuth();
  const location = useLocation();

  const isFreelancer = Boolean(authToken);
  const isClient = Boolean(magicToken && clientData);

  // 1. Not logged in at all
  if (!isFreelancer && !isClient) {
    return <Navigate to="/login" replace />;
  }

  // 2. Logged in as client but trying to access freelancer route
  if (isClient && location.pathname.startsWith('/dashboard')) {
    return <Navigate to={`/client-dashboard/${clientData.default_project_id || ''}`} replace />;
  }

  // 3. Logged in as freelancer but trying to access client dashboard
  if (isFreelancer && location.pathname.startsWith('/client-dashboard')) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PrivateRoute;